import React, {PropTypes as T} from 'react';
import GASelection from './gaselection';
import GASubmit from './gasubmit';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import Button from '../../common/button';
import ModalCloseIcon from '../../common/icons/icon_close2';
import translate from '../../../utils/translate';
import withDevice from '../../common/withDeviceHOC';
import basketActions from '../../../actions/basket';
import EventTicketLimit from '../errors/event_ticket_limit';
import SIM from '../../../sim/core';
import MemberTicketLimit from '../errors/member_ticket_limit_error';
import {getActiveSection, getSectionName} from '../../../utils/sim/geometry_utils';
import flatten from 'lodash/flatten';
import sum from 'lodash/sum';
import noScroll from '../../../utils/noscroll';
import values from 'lodash/values';

const mapActions = SIM.actions.map;

class MAPGAPicker extends React.Component {
  static propTypes = {
    map: T.object,
    basket: T.object.isRequired,
    isBasketFull: T.bool.isRequired,
    isMemberLimitReached: T.bool.isRequired,
    isMobile: T.bool
  };

  state = { isOpen: true };

  closeModal = () => {
    this.setState({ isOpen: false }, () => {
      setTimeout(this.undoSelection, 300);
    });
  };

  undoSelection = () => {
    noScroll.off();
    mapActions.emit(mapActions.EVENTS.SECTION_RESET);
    basketActions.resetGASectionTicketQuantity();
    this.setState({ isOpen: true });
  };

  // TODO: This should be moved to store as a computed property
  totalQuantityInSelection = (sectionBasket) => {
    const qunatities = values(sectionBasket).map(x => values(x));
    return sum(flatten(qunatities).map(x => x.qty));
  };

  totalQuantityInSection = (ticketInSection) => {
    return ticketInSection
      ? values(ticketInSection).reduce((acc, entry) => {
        return acc + (Number(entry.qty) || 0);
      }, 0)
      : 0;
  };

  getFooter = (activeSection) => {
    const sectionBasket = this.props.basket.sectionBasket;
    const isDisabled = (this.totalQuantityInSelection(sectionBasket) === 0);
    return <GASubmit section={activeSection} sectionBasket={sectionBasket} disabled={isDisabled} />;
  };

  renderMemberTicketLimit = () => {
    return (
      <MemberTicketLimit
        memberTicketLimit={this.props.basket.config.memberTicketLimit}
        translations={this.props.basket.error.translations}
        onClose={this.undoSelection} />
    );
  };

  renderEventTicketLimit = () => {
    const ticketLimit = this.props.basket.config.ticketLimit;
    return (
      <EventTicketLimit
        title={translate('pageTranslations', 'CART_FULL_HEADER', {'%MAX_TICKETS%': ticketLimit})}
        ticketLimit={ticketLimit}
        onClickOutside={this.undoSelection} />
    );
  };

  shouldRender = (activeSection) => {
    // should render if it's a valid GA section with available seats
    // OR we're in seatmap overview mode and it's a normal section with available seats
    return (
      (activeSection && activeSection.isGA && activeSection.availableSeatCount) ||
      (this.props.basket.config.seatmapDisplayOverviewMode && activeSection && activeSection.availableSeatCount)
    );
  };

  render () {
    const activeSection = getActiveSection(this.props.map.geometry, this.props.map.activeSection);

    if (!this.shouldRender(activeSection)) {
      return <Modal />;
    }

    // Show a notification message indicating that the basket is full if the user is
    // trying to open up a GA overlay when the ticket limit is already reached

    // MemberTicketLimit should have precedence over EventTicketLimit
    if (this.props.isMemberLimitReached) {
      return this.renderMemberTicketLimit();
    }

    if (this.props.isBasketFull) {
      return this.renderEventTicketLimit();
    }

    const sectionName = (
      getSectionName(activeSection, this.props.basket.areaNames) ||
      translate('ismModule', 'PLEASE_SELECT_YOUR_TICKETS')
    );

    const ticketsInSection =
      this.props.basket &&
      this.props.basket.quantityInSections &&
      activeSection &&
      activeSection.priceCategories &&
      this.props.basket.quantityInSections[activeSection.id] &&
      this.props.basket.quantityInSections[activeSection.id][activeSection.priceCategories[0]] || 0;

    return (
      <Modal
        dataComponent="generaladmissions-modal"
        isOpen={this.state.isOpen}
        onClose={this.closeModal}
        width={!this.props.isMobile && 480}
      >
        <ModalHeader isInfo>
          <div className="modal__header_title">{sectionName}</div>
          <Button icon onClick={this.closeModal} data-component="modal__close_button">
            <ModalCloseIcon className="modal__header__close_icon" />
          </Button>
        </ModalHeader>
        <ModalContent seamless>
          <div className="ismmodal" data-component="gapicker">
            <div className="ismmodal__header">
              <SIM.Views.StaticMap static />
            </div>
            <GASelection
              {...this.props}
              section={activeSection}
              totalQuantityInSelection={this.totalQuantityInSelection(this.props.basket.sectionBasket)}
              totalQuantityInSection={this.totalQuantityInSection(ticketsInSection)} />
          </div>
        </ModalContent>
        <ModalFooter>
          {this.getFooter(activeSection)}
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(SIM.StoreConnect(MAPGAPicker, {map: SIM.stores.map}));



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/index.js